// src/api/captchaApi.ts
import axios, { AxiosInstance } from "axios";
import type {
    CaptchaResponse,
    CaptchaVerifyResponse,
} from "@/types/CaptchaTypes";

export const CAPTCHA_APP_NAME = "userpanel";

const captchaApi: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL_CAPTCHA,
    headers: {
        "Content-Type": "application/json",
    },
});

export const getCaptcha = async (
    appName: string = CAPTCHA_APP_NAME
): Promise<CaptchaResponse> => {
    const { data } = await captchaApi.get<CaptchaResponse>("/api/v1/captcha", {
        params: { app_name: appName },
    });
    return data;
};
